// @ts-nocheck
/* eslint-disable */

// # The following lists all copyright notices and licenses for the
// # work contained in JavascriptSubtitlesOctopus per project.
//
// # Project: subtitlesoctopus
// License: Expat
// Copyright: 2017-2021 JavascriptSubtitlesOctopus contributors
//
// # Project: brotli
// License: Expat
// Copyright: 2014 Google Inc.
//   2015 The Chromium Authors.
//   2016 Google Inc.
//   2017 Google Inc.
//   2018 Google Inc.
//   2015 Google Inc.
//   2013 Google Inc.
//   2009, 2010, 2013-2016 by the Brotli Authors
//   2010 Google Inc.
//
// # Project: expat
// License: Expat
// Copyright: 2019 Zhongyuan Zhou <zhouzhongyuan@huawei.com>
//   2020 Joe Orton <jorton@redhat.com>
//   2016-2019 Sebastian Pipping <sebastian@pipping.org>
//   2021 Dong-hee Na <donghee.na@python.org>
//   2017 Joe Orton <jorton@redhat.com>
//   2002 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2004-2006 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2017 Sebastian Pipping <sebastian@pipping.org>
//   2004-2006 Karl Waclawek <karl@waclawek.net>
//   2006 Karl Waclawek <karl@waclawek.net>
//   2003-2006 Karl Waclawek <karl@waclawek.net>
//   2001-2003 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2000-2004 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2017 Franek Korta <fkorta@gmail.com>
//   2001-2004 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2006-2012 Karl Waclawek <karl@waclawek.net>
//   2017 Benbuck Nason <bnason@netflix.com>
//   2019 David Loffredo <loffredo@steptools.com>
//   2021 Tim Bray <tbray@textuality.com>
//   2018 Benjamin Peterson <benjamin@python.org>
//   2017 Rhodri James <rhodri@wildebeest.org.uk>
//   2002-2005 Karl Waclawek <karl@waclawek.net>
//   2016-2020 Sebastian Pipping <sebastian@pipping.org>
//   2016-2018 Sebastian Pipping <sebastian@pipping.org>
//   2016 Gilles Espinasse <g.esp@free.fr>
//   2007 Karl Waclawek <karl@waclawek.net>
//   2002-2016 Karl Waclawek <karl@waclawek.net>
//   2001-2006 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2016 Don Lewis <truckman@apache.org>
//   2000-2017 Expat development team
//   2002-2004 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2000 Clark Cooper <coopercc@users.sourceforge.net>
//   2002 Greg Stein <gstein@users.sourceforge.net>
//   2018 Marco Maggi <marco.maggi-ipsu@poste.it>
//   2017-2018 Rhodri James <rhodri@wildebeest.org.uk>
//   2005-2012 Karl Waclawek <karl@waclawek.net>
//   2020 Boris Kolpackov <boris@codesynthesis.com>
//   2022 Thijs Schreijer <thijs@thijsschreijer.nl>
//   2017-2019 Sebastian Pipping <sebastian@pipping.org>
//   2016 Cristian Rodr\x{00c3}\x{00ad}guez <crrodriguez@opensuse.org>
//   2005 Karl Waclawek <karl@waclawek.net>
//   1999-2000 Thai Open Source Software Center Ltd
//   2000-2017 Expat development team / 1997-2000 Thai Open Source Software Center Ltd
//   2005-2007 Steven Solie <steven@solie.ca>
//   2016-2021 Sebastian Pipping <sebastian@pipping.org>
//   2005 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2018 Anton Maklakov <antmak.pub@gmail.com>
//   2017 Alexander Bluhm <alexander.bluhm@gmx.net>
//   1997-2000 Thai Open Source Software Center Ltd
//   2016-2022 Sebastian Pipping <sebastian@pipping.org>
//   2017-2021 Sebastian Pipping <sebastian@pipping.org>
//   2002-2009 Karl Waclawek <karl@waclawek.net>
//   2002 Karl Waclawek <karl@waclawek.net>
//   2004-2009 Karl Waclawek <karl@waclawek.net>
//   2020 Tim Gates <tim.gates@iress.com>
//   2016 Pascal Cuoq <cuoq@trust-in-soft.com>
//   2017 Jos\x{00c3}\x{00a9} Guti\x{00c3}\x{00a9}rrez de la Concha <jose@zeroc.com>
//   2001-2002 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2002-2006 Karl Waclawek <karl@waclawek.net>
//   2000-2005 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2005-2009 Steven Solie <steven@solie.ca>
//   2018 Yury Gribov <tetra2005@gmail.com>
//   2003 Greg Stein <gstein@users.sourceforge.net>
//   2016-2017 Sebastian Pipping <sebastian@pipping.org>
//   2020 Kleber Tarc\x{00c3}\x{00ad}sio <klebertarcisio@yahoo.com.br>
//   2001-2002 Greg Stein <gstein@users.sourceforge.net>
//   2002-2003 Fred L. Drake, Jr. <fdrake@users.sourceforge.net>
//   2005-2006 Karl Waclawek <karl@waclawek.net>
//   2016 Thomas Beutlich <tc@tbeu.de>
//
// # Project: freetype
// License: FTL
// Copyright: \x{00c5}\x{009d}\x{00c5}\x{00a5} \x{00c5}\x{009d}\x{00c5}\x{00a5}\x{00d1}\x{008f}\x{00c3}\x{00af}\x{00ef}\x{00ac}\x{00af}\x{00c4}\x{009f}")
//   2001-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2009-2013 Adobe Systems Incorporated.
//   2017-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   1995-2002 Mark Adler
//   2013 Adobe Systems Incorporated.
//   2005-2021 David Turner.
//   2004-2021 Masatake YAMATO and Redhat K.K.
//   2006-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2007-2014 Adobe Systems Incorporated.
//   2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2010-2021 Joel Klinghed.
//   2007-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   1996-2021 David Turner, Robert Wilhelm, and Werner Lemberg
//   \x{00c5}\x{009d}\x{00c5}\x{00a5} \x{00c5}\x{009d}\x{00c5}\x{00a5}\x{00d1}\x{008f}\x{00c3}\x{00af}\x{00ef}\x{00ac}\x{00af}\x{00c4}\x{009f}"));
//   2005-2021 Werner Lemberg and Detlef W\x{00fc}rkner.
//   2002-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2003 Huw D M Davies for Codeweavers
//   2004-2021 David Turner, Robert Wilhelm, Werner Lemberg, and George Williams.
//   2013-2014 Adobe Systems Incorporated.
//   1996-2021 David Turner, Robert Wilhelm, Werner Lemberg, and Detlef Wuerkner.
//   2000-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2007-2021 David Turner.
//   2011-2013 Adobe Systems Incorporated.
//   2007 Dmitry Timoshkov for Codeweavers
//   2004-2021 David Turner, Robert Wilhelm, Werner Lemberg and George Williams.
//   2018-2021 Armin Hasitzka, David Turner, Robert Wilhelm, and Werner Lemberg.
//   2012-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2007-2021 Dereg Clegg and Michael Toftdal.
//   1996-2021 Just van Rossum, David Turner, Robert Wilhelm, and Werner Lemberg.
//   2019-2021 Nikhil Ramakrishnan, David Turner, Robert Wilhelm, and Werner Lemberg.
//   1996-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2003-2021 Masatake YAMATO, Redhat K.K.,
//   2008-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2009-2021 Oran Agra and Mickey Gabel.
//   2006-2013 Adobe Systems Incorporated.
//   2013-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2004-2021 Masatake YAMATO, Red Hat K.K.,
//   2016-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2002-2021 Roberto Alameda.
//   2020-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2007-2021 Rahul Bhalerao <rahul.bhalerao@redhat.com>, <b.rahul.pm@gmail.com>.
//   1995-2002 Jean-loup Gailly.
//   2004-2021 suzuki toshiya, Masatake YAMATO, Red Hat K.K.,
//   2018-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2004-2021 Albert Chin-A-Young.
//   2018-2021 David Turner, Robert Wilhelm, Dominik R\x{00c3}\x{00b6}ttsches, and Werner Lemberg.
//   2002-2021 David Turner, Robert Wilhelm, and Werner Lemberg
//   \x{00e1}\x{00bb}\x{008b}...): %dn", "\x{00e1}\x{00ba}\x{0083}\x{00ce}\x{00ad}\x{00c5}\x{0082}\x{00c4}\x{00ba}", "all", 42);
//   2013 Google, Inc.
//   2005-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2009-2014 Adobe Systems Incorporated.
//   2010-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2013-2021 Google, Inc.
//   2007-2013 Adobe Systems Incorporated.
//   2001, 2012 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2007-2021 Derek Clegg and Michael Toftdal.
//   2003-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2008-2021 David Turner, Robert Wilhelm, Werner Lemberg, and suzuki toshiya.
//   1990, 1994, 1998 The Open Group
//   2004-2021 David Turner, Robert Wilhelm, and Werner Lemberg.
//   2005-2021 suzuki toshiya, Masatake YAMATO, Red Hat K.K.,
//   1996-2021 David Turner, Robert Wilhelm, Werner Lemberg and Detlef W\x{00fc}rkner.
//   2004-2021 Masatake YAMATO, Redhat K.K,
//
// License: public-domain
// Copyright: 2001 Alexander Peslyak and it is hereby released to the
//
// License: Zlib
// Copyright: 1995-2002 Jean-loup Gailly and Mark Adler
//
// License: Expat
// Copyright: 2000-2001, 2004 Francesco Zappa Nardelli
//   2001-2004 Francesco Zappa Nardelli
//   2003 Francesco Zappa Nardelli
//   2001-2015 Francesco Zappa Nardelli
//   2001-2004, 2011 Francesco Zappa Nardelli
//   2000-2002 Francesco Zappa Nardelli
//   2000 Computing Research Labs, New Mexico State University
//   2001-2014 Francesco Zappa Nardelli
//   2001-2002, 2012 Francesco Zappa Nardelli
//   2001-2002 Francesco Zappa Nardelli
//   2001-2008, 2011, 2013-2014 Francesco Zappa Nardelli
//   2000-2003, 2006, 2010 Francesco Zappa Nardelli
//   2000-2001, 2003 Francesco Zappa Nardelli
//   2000-2004, 2006-2011, 2013-2014 Francesco Zappa Nardelli
//   2000-2010, 2012-2014 Francesco Zappa Nardelli
//
// License: BSL-1.0
// Copyright: 2019 nyorain
//
// # Project: fribidi
// License: LGPL-2.1+
// Copyright: 1999-2000, 2017 Dov Grobgeld
//   1999-2000 Dov Grobgeld
//   2004 Behdad Esfahbod
//   2001-2002, 2004 Behdad Esfahbod
//   2009 Behdad Esfahbod
//   2017 Dov Grobgeld
//   2004-2005 Behdad Esfahbod
//   2004 Sharif FarsiWeb, Inc.
//   2015, 2017 Dov Grobgeld
//   2005 Behdad Esfahbod
//   2001 Behdad Esfahbod.
//   2001-2002 Behdad Esfahbod
//   2004 Sharif FarsiWeb, Inc
//
// # Project: fontconfig
// License: NTP~disclaimer
// Copyright: 2002 Keith Packard
//   2009 Roozbeh Pournader
//   2000 Tuomas J. Lukka
//   2006 Keith Packard
//   2008 Red Hat, Inc.
//   2000-2007 Keith Packard / 2005 Patrick Lam / 2009 Roozbeh Pournader / 2008,2009 Red Hat, Inc. / 2008 Danilo Šegan / 2012 Google, Inc.
//   2001 Keith Packard
//   2012 Google, Inc.
//   2012 Red Hat, Inc.
//   2013 Raimund Steger
//   2008,2009 Red Hat, Inc.
//   2000-2007 Keith Packard
//   2005 Patrick Lam
//   2003 Keith Packard
//   2020 Zoltan Vandrus
//   \x{00e6}\x{0081}\x{00af} 2010 Behdad Esfahbod
//   2014 Red Hat, Inc.
//   2018 Akira TAGOH
//   2007 Keith Packard
//   \x{00e6}\x{0081}\x{00af} 2006 Keith Packard
//   2008 Danilo Šegan
//   2015 Akira TAGOH
//   2016 Akira TAGOH
//   2008-2009 Red Hat, Inc.
//   2000 Keith Packard
//   2013 Akira TAGOH
//   2013 Google, Inc.
//   2010 Behdad Esfahbod
//
// License: MIT~old
// Copyright: 2009-2010 Red Hat, Inc.
//   2011-2013 Google, Inc.
//   2007 Chris Wilson
//
// License: public-domain
// Copyright: 2008,2009 Red Hat, Inc.
//   2009 Roozbeh Pournader
//   2012 Google, Inc.
//   2008 Danilo Šegan
//   2005 Patrick Lam
//   2000-2007 Keith Packard
//
// License: Expat
// Copyright: 2002-2003 Juliusz Chroboczek
//
// # Project: harfbuzz
// License: NTP~disclaimer
// Copyright: 2002 Keith Packard
//   2014 Google, Inc.
//
// License: MIT~old
// Copyright: 2012 Mozilla Foundation.
//   2004, 2007, 2009 Red Hat, Inc.
//   2009 Red Hat, Inc.
//   2015 Google, Inc.
//   2014 Google, Inc.
//   2018 Ebrahim Byagowi
//   2016 Igalia S.L.
//   2018 Ebrahim Byagowi.
//   2011 Martin Hosken
//   2019 Ebrahim Byagowi
//   1998-2004 David Turner and Werner Lemberg
//   2020 Ebrahim Byagowi
//   2013 Red Hat, Inc.
//   2011-2012 Google, Inc.
//   2011 SIL International
//   2018 Khaled Hosny
//   2018 Google, Inc.
//   2019-2020 Ebrahim Byagowi
//   2012 Google, Inc.
//   2017 Google, Inc.
//   2007-2009 Red Hat, Inc.
//   2011 Codethink Limited
//   2013 Google, Inc.
//   2015-2019 Ebrahim Byagowi
//   2016 Google, Inc.
//   2011 Google, Inc.
//
// # Project: libass
// License: public-domain
// Copyright: 2006-2016 libass contributors
//
// License: NTP
// Copyright: 1994 Sun Microsystems, Inc.
//   2016 Oleg Oshmyan <chortos@inbox.lv>
//   1988-1993 The Regents of the University of California.
//
// License: ISC
// Copyright: 2015 Oleg Oshmyan <chortos@inbox.lv>
//   2011-2014 Yu Zhuohuang <yuzhuohuang@qq.com>
//   2013 rcombs <rcombs@rcombs.me>
//   2016 Vabishchevich Nikolay <vabnick@gmail.com>
//   2015 Stephan Vedder <stephan.vedder@gmail.com>
//   2015 Vabishchevich Nikolay <vabnick@gmail.com>
//   interest in the
//   2006-2016 libass contributors
//   2021 libass contributors
//   2017 Vabishchevich Nikolay <vabnick@gmail.com>
//   2011 Grigori Goronzy <greg@chown.ath.cx>
//   2010 Grigori Goronzy <greg@geekmind.org>
//   2014 Vabishchevich Nikolay <vabnick@gmail.com>
//   2015 Grigori Goronzy <greg@kinoho.net>
//   2013 Stefano Pigozzi <stefano.pigozzi@gmail.com>
//   2006 Evgeniy Stepanov <eugeni.stepanov@gmail.com>
//   2009 Grigori Goronzy <greg@geekmind.org>
//
// # The following section contains the full license text or
// # where permitted a shorter notice for all works contained
// # in JavascriptSubtitlesOctopus listed above
// #
// # Note that the shortnames used here are identical to those used by Debian
// # and will in some cases differ from SPDX identifiers. See below.
// #
// #   Debian-name    | SPDX-name
// #   ---------------+-------------------
// #   MIT~old        | MIT-Modern-Variant
// #   Expat          | MIT
// #   NTP~disclaimer | (None; it is NTP with a more verbose warranty disclaimer)
//
// License: Expat
//   Permission is  hereby granted,  free of charge,  to any  person obtaining
//   a  copy  of  this  software   and  associated  documentation  files  (the
//   "Software"),  to  deal in  the  Software  without restriction,  including
//   without  limitation the  rights  to use,  copy,  modify, merge,  publish,
//   distribute, sublicense, and/or sell copies of the Software, and to permit
//   persons  to whom  the Software  is  furnished to  do so,  subject to  the
//   following conditions:
//   .
//   The above copyright  notice and this permission notice  shall be included
//   in all copies or substantial portions of the Software.
//   .
//   THE  SOFTWARE  IS  PROVIDED  "AS  IS",  WITHOUT  WARRANTY  OF  ANY  KIND,
//   EXPRESS  OR IMPLIED,  INCLUDING  BUT  NOT LIMITED  TO  THE WARRANTIES  OF
//   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//   NO EVENT SHALL THE AUTHORS OR  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//   DAMAGES OR  OTHER LIABILITY, WHETHER  IN AN  ACTION OF CONTRACT,  TORT OR
//   OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//   USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// License: FTL
//   Portions of this software are copyright © 2021 The FreeType
//   Project (www.freetype.org).  All rights reserved.
//   A copy of the FreeType License can be obtained at
//   https://gitlab.freedesktop.org/freetype/freetype/-/blob/master/docs/FTL.TXT
//
// License: ISC
//   Permission to use, copy, modify, and/or distribute this software for any
//   purpose with or without fee is hereby granted, provided that the above
//   copyright notice and this permission notice appear in all copies.
//   .
//   THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
//   WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
//   MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
//   ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
//   WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
//   ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
//   OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
//
// License: MIT~old
//   Permission is hereby granted, without written agreement and without
//   license or royalty fees, to use, copy, modify, and distribute this
//   software and its documentation for any purpose, provided that the
//   above copyright notice and the following two paragraphs appear in
//   all copies of this software.
//   .
//   IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR
//   DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES
//   ARISING OUT OF THE USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN
//   IF THE COPYRIGHT HOLDER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
//   DAMAGE.
//   .
//   THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING,
//   BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
//   FITNESS FOR A PARTICULAR PURPOSE.  THE SOFTWARE PROVIDED HEREUNDER IS
//   ON AN "AS IS" BASIS, AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO
//   PROVIDE MAINTENANCE, SUPPORT, UPDATES, ENHANCEMENTS, OR MODIFICATIONS
//
// License: NTP
//   Permission to use, copy, modify, and distribute this
//   software and its documentation for any purpose and without
//   fee is hereby granted, provided that the above copyright
//   notice appear in all copies.  The University of California
//   makes no representations about the suitability of this
//   software for any purpose.  It is provided "as is" without
//   express or implied warranty.
//
// License: NTP~disclaimer
//   Permission to use, copy, modify, distribute, and sell this software and its
//   documentation for any purpose is hereby granted without fee, provided that
//   the above copyright notice appear in all copies and that both that
//   copyright notice and this permission notice appear in supporting
//   documentation, and that the name of the author(s) not be used in
//   advertising or publicity pertaining to distribution of the software without
//   specific, written prior permission.  The authors make no
//   representations about the suitability of this software for any purpose.  It
//   is provided "as is" without express or implied warranty.
//   .
//   THE AUTHOR(S) DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE,
//   INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS, IN NO
//   EVENT SHALL THE AUTHOR(S) BE LIABLE FOR ANY SPECIAL, INDIRECT OR
//   CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
//   DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
//   TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
//   PERFORMANCE OF THIS SOFTWARE.
//
// License: Zlib
//   This software is provided 'as-is', without any express or implied
//   warranty.  In no event will the authors be held liable for any damages
//   arising from the use of this software.
//   .
//   Permission is granted to anyone to use this software for any purpose,
//   including commercial applications, and to alter it and redistribute it
//   freely, subject to the following restrictions:
//   .
//   1. The origin of this software must not be misrepresented; you must not
//      claim that you wrote the original software. If you use this software
//      in a product, an acknowledgment in the product documentation would be
//      appreciated but is not required.
//   2. Altered source versions must be plainly marked as such, and must not be
//      misrepresented as being the original software.
//   3. This notice may not be removed or altered from any source distribution.
//
// License: BSL-1
//   Boost Software License - Version 1.0 - August 17th, 2003
//   .
//   Permission is hereby granted, free of charge, to any person or organization
//   obtaining a copy of the software and accompanying documentation covered by
//   this license (the "Software") to use, reproduce, display, distribute,
//   execute, and transmit the Software, and to prepare derivative works of the
//   Software, and to permit third-parties to whom the Software is furnished to
//   do so, all subject to the following:
//   .
//   The copyright notices in the Software and this entire statement, including
//   the above license grant, this restriction and the following disclaimer,
//   must be included in all copies of the Software, in whole or in part, and
//   all derivative works of the Software, unless such copies or derivative
//   works are solely in the form of machine-executable object code generated by
//   a source language processor.
//   .
//   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
//   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//   FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT. IN NO EVENT
//   SHALL THE COPYRIGHT HOLDERS OR ANYONE DISTRIBUTING THE SOFTWARE BE LIABLE
//   FOR ANY DAMAGES OR OTHER LIABILITY, WHETHER IN CONTRACT, TORT OR OTHERWISE,
//   ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
//   DEALINGS IN THE SOFTWARE.
//
// License: LGPL-2.1
//             GNU LESSER GENERAL PUBLIC LICENSE
//                  Version 2.1, February 1999
//   .
//    Copyright (C) 1991, 1999 Free Software Foundation, Inc.
//        51 Franklin Street, Fifth Floor, Boston, MA  02110-1301  USA
//    Everyone is permitted to copy and distribute verbatim copies
//    of this license document, but changing it is not allowed.
//   .
//   [This is the first released version of the Lesser GPL.  It also counts
//    as the successor of the GNU Library Public License, version 2, hence
//    the version number 2.1.]
//   .
//                   Preamble
//   .
//     The licenses for most software are designed to take away your
//   freedom to share and change it.  By contrast, the GNU General Public
//   Licenses are intended to guarantee your freedom to share and change
//   free software--to make sure the software is free for all its users.
//   .
//     This license, the Lesser General Public License, applies to some
//   specially designated software packages--typically libraries--of the
//   Free Software Foundation and other authors who decide to use it.  You
//   can use it too, but we suggest you first think carefully about whether
//   this license or the ordinary General Public License is the better
//   strategy to use in any particular case, based on the explanations below.
//   .
//     When we speak of free software, we are referring to freedom of use,
//   not price.  Our General Public Licenses are designed to make sure that
//   you have the freedom to distribute copies of free software (and charge
//   for this service if you wish); that you receive source code or can get
//   it if you want it; that you can change the software and use pieces of
//   it in new free programs; and that you are informed that you can do
//   these things.
//   .
//     To protect your rights, we need to make restrictions that forbid
//   distributors to deny you these rights or to ask you to surrender these
//   rights.  These restrictions translate to certain responsibilities for
//   you if you distribute copies of the library or if you modify it.
//   .
//     For example, if you distribute copies of the library, whether gratis
//   or for a fee, you must give the recipients all the rights that we gave
//   you.  You must make sure that they, too, receive or can get the source
//   code.  If you link other code with the library, you must provide
//   complete object files to the recipients, so that they can relink them
//   with the library after making changes to the library and recompiling
//   it.  And you must show them these terms so they know their rights.
//   .
//     We protect your rights with a two-step method: (1) we copyright the
//   library, and (2) we offer you this license, which gives you legal
//   permission to copy, distribute and/or modify the library.
//   .
//     To protect each distributor, we want to make it very clear that
//   there is no warranty for the free library.  Also, if the library is
//   modified by someone else and passed on, the recipients should know
//   that what they have is not the original version, so that the original
//   author's reputation will not be affected by problems that might be
//   introduced by others.
//   .
//     Finally, software patents pose a constant threat to the existence of
//   any free program.  We wish to make sure that a company cannot
//   effectively restrict the users of a free program by obtaining a
//   restrictive license from a patent holder.  Therefore, we insist that
//   any patent license obtained for a version of the library must be
//   consistent with the full freedom of use specified in this license.
//   .
//     Most GNU software, including some libraries, is covered by the
//   ordinary GNU General Public License.  This license, the GNU Lesser
//   General Public License, applies to certain designated libraries, and
//   is quite different from the ordinary General Public License.  We use
//   this license for certain libraries in order to permit linking those
//   libraries into non-free programs.
//   .
//     When a program is linked with a library, whether statically or using
//   a shared library, the combination of the two is legally speaking a
//   combined work, a derivative of the original library.  The ordinary
//   General Public License therefore permits such linking only if the
//   entire combination fits its criteria of freedom.  The Lesser General
//   Public License permits more lax criteria for linking other code with
//   the library.
//   .
//     We call this license the "Lesser" General Public License because it
//   does Less to protect the user's freedom than the ordinary General
//   Public License.  It also provides other free software developers Less
//   of an advantage over competing non-free programs.  These disadvantages
//   are the reason we use the ordinary General Public License for many
//   libraries.  However, the Lesser license provides advantages in certain
//   special circumstances.
//   .
//     For example, on rare occasions, there may be a special need to
//   encourage the widest possible use of a certain library, so that it becomes
//   a de-facto standard.  To achieve this, non-free programs must be
//   allowed to use the library.  A more frequent case is that a free
//   library does the same job as widely used non-free libraries.  In this
//   case, there is little to gain by limiting the free library to free
//   software only, so we use the Lesser General Public License.
//   .
//     In other cases, permission to use a particular library in non-free
//   programs enables a greater number of people to use a large body of
//   free software.  For example, permission to use the GNU C Library in
//   non-free programs enables many more people to use the whole GNU
//   operating system, as well as its variant, the GNU/Linux operating
//   system.
//   .
//     Although the Lesser General Public License is Less protective of the
//   users' freedom, it does ensure that the user of a program that is
//   linked with the Library has the freedom and the wherewithal to run
//   that program using a modified version of the Library.
//   .
//     The precise terms and conditions for copying, distribution and
//   modification follow.  Pay close attention to the difference between a
//   "work based on the library" and a "work that uses the library".  The
//   former contains code derived from the library, whereas the latter must
//   be combined with the library in order to run.
//   .
//             GNU LESSER GENERAL PUBLIC LICENSE
//      TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION
//   .
//     0. This License Agreement applies to any software library or other
//   program which contains a notice placed by the copyright holder or
//   other authorized party saying it may be distributed under the terms of
//   this Lesser General Public License (also called "this License").
//   Each licensee is addressed as "you".
//   .
//     A "library" means a collection of software functions and/or data
//   prepared so as to be conveniently linked with application programs
//   (which use some of those functions and data) to form executables.
//   .
//     The "Library", below, refers to any such software library or work
//   which has been distributed under these terms.  A "work based on the
//   Library" means either the Library or any derivative work under
//   copyright law: that is to say, a work containing the Library or a
//   portion of it, either verbatim or with modifications and/or translated
//   straightforwardly into another language.  (Hereinafter, translation is
//   included without limitation in the term "modification".)
//   .
//     "Source code" for a work means the preferred form of the work for
//   making modifications to it.  For a library, complete source code means
//   all the source code for all modules it contains, plus any associated
//   interface definition files, plus the scripts used to control compilation
//   and installation of the library.
//   .
//     Activities other than copying, distribution and modification are not
//   covered by this License; they are outside its scope.  The act of
//   running a program using the Library is not restricted, and output from
//   such a program is covered only if its contents constitute a work based
//   on the Library (independent of the use of the Library in a tool for
//   writing it).  Whether that is true depends on what the Library does
//   and what the program that uses the Library does.
//
//     1. You may copy and distribute verbatim copies of the Library's
//   complete source code as you receive it, in any medium, provided that
//   you conspicuously and appropriately publish on each copy an
//   appropriate copyright notice and disclaimer of warranty; keep intact
//   all the notices that refer to this License and to the absence of any
//   warranty; and distribute a copy of this License along with the
//   Library.
//   .
//     You may charge a fee for the physical act of transferring a copy,
//   and you may at your option offer warranty protection in exchange for a
//   fee.
//   .
//     2. You may modify your copy or copies of the Library or any portion
//   of it, thus forming a work based on the Library, and copy and
//   distribute such modifications or work under the terms of Section 1
//   above, provided that you also meet all of these conditions:
//   .
//       a) The modified work must itself be a software library.
//   .
//       b) You must cause the files modified to carry prominent notices
//       stating that you changed the files and the date of any change.
//   .
//       c) You must cause the whole of the work to be licensed at no
//       charge to all third parties under the terms of this License.
//   .
//       d) If a facility in the modified Library refers to a function or a
//       table of data to be supplied by an application program that uses
//       the facility, other than as an argument passed when the facility
//       is invoked, then you must make a good faith effort to ensure that,
//       in the event an application does not supply such function or
//       table, the facility still operates, and performs whatever part of
//       its purpose remains meaningful.
//   .
//       (For example, a function in a library to compute square roots has
//       a purpose that is entirely well-defined independent of the
//       application.  Therefore, Subsection 2d requires that any
//       application-supplied function or table used by this function must
//       be optional: if the application does not supply it, the square
//       root function must still compute square roots.)
//   .
//   These requirements apply to the modified work as a whole.  If
//   identifiable sections of that work are not derived from the Library,
//   and can be reasonably considered independent and separate works in
//   themselves, then this License, and its terms, do not apply to those
//   sections when you distribute them as separate works.  But when you
//   distribute the same sections as part of a whole which is a work based
//   on the Library, the distribution of the whole must be on the terms of
//   this License, whose permissions for other licensees extend to the
//   entire whole, and thus to each and every part regardless of who wrote
//   it.
//   .
//   Thus, it is not the intent of this section to claim rights or contest
//   your rights to work written entirely by you; rather, the intent is to
//   exercise the right to control the distribution of derivative or
//   collective works based on the Library.
//   .
//   In addition, mere aggregation of another work not based on the Library
//   with the Library (or with a work based on the Library) on a volume of
//   a storage or distribution medium does not bring the other work under
//   the scope of this License.
//   .
//     3. You may opt to apply the terms of the ordinary GNU General Public
//   License instead of this License to a given copy of the Library.  To do
//   this, you must alter all the notices that refer to this License, so
//   that they refer to the ordinary GNU General Public License, version 2,
//   instead of to this License.  (If a newer version than version 2 of the
//   ordinary GNU General Public License has appeared, then you can specify
//   that version instead if you wish.)  Do not make any other change in
//   these notices.
//   .
//     Once this change is made in a given copy, it is irreversible for
//   that copy, so the ordinary GNU General Public License applies to all
//   subsequent copies and derivative works made from that copy.
//   .
//     This option is useful when you wish to copy part of the code of
//   the Library into a program that is not a library.
//   .
//     4. You may copy and distribute the Library (or a portion or
//   derivative of it, under Section 2) in object code or executable form
//   under the terms of Sections 1 and 2 above provided that you accompany
//   it with the complete corresponding machine-readable source code, which
//   must be distributed under the terms of Sections 1 and 2 above on a
//   medium customarily used for software interchange.
//   .
//     If distribution of object code is made by offering access to copy
//   from a designated place, then offering equivalent access to copy the
//   source code from the same place satisfies the requirement to
//   distribute the source code, even though third parties are not
//   compelled to copy the source along with the object code.
//   .
//     5. A program that contains no derivative of any portion of the
//   Library, but is designed to work with the Library by being compiled or
//   linked with it, is called a "work that uses the Library".  Such a
//   work, in isolation, is not a derivative work of the Library, and
//   therefore falls outside the scope of this License.
//   .
//     However, linking a "work that uses the Library" with the Library
//   creates an executable that is a derivative of the Library (because it
//   contains portions of the Library), rather than a "work that uses the
//   library".  The executable is therefore covered by this License.
//   Section 6 states terms for distribution of such executables.
//   .
//     When a "work that uses the Library" uses material from a header file
//   that is part of the Library, the object code for the work may be a
//   derivative work of the Library even though the source code is not.
//   Whether this is true is especially significant if the work can be
//   linked without the Library, or if the work is itself a library.  The
//   threshold for this to be true is not precisely defined by law.
//   .
//     If such an object file uses only numerical parameters, data
//   structure layouts and accessors, and small macros and small inline
//   functions (ten lines or less in length), then the use of the object
//   file is unrestricted, regardless of whether it is legally a derivative
//   work.  (Executables containing this object code plus portions of the
//   Library will still fall under Section 6.)
//   .
//     Otherwise, if the work is a derivative of the Library, you may
//   distribute the object code for the work under the terms of Section 6.
//   Any executables containing that work also fall under Section 6,
//   whether or not they are linked directly with the Library itself.
//   .
//     6. As an exception to the Sections above, you may also combine or
//   link a "work that uses the Library" with the Library to produce a
//   work containing portions of the Library, and distribute that work
//   under terms of your choice, provided that the terms permit
//   modification of the work for the customer's own use and reverse
//   engineering for debugging such modifications.
//   .
//     You must give prominent notice with each copy of the work that the
//   Library is used in it and that the Library and its use are covered by
//   this License.  You must supply a copy of this License.  If the work
//   during execution displays copyright notices, you must include the
//   copyright notice for the Library among them, as well as a reference
//   directing the user to the copy of this License.  Also, you must do one
//   of these things:
//   .
//       a) Accompany the work with the complete corresponding
//       machine-readable source code for the Library including whatever
//       changes were used in the work (which must be distributed under
//       Sections 1 and 2 above); and, if the work is an executable linked
//       with the Library, with the complete machine-readable "work that
//       uses the Library", as object code and/or source code, so that the
//       user can modify the Library and then relink to produce a modified
//       executable containing the modified Library.  (It is understood
//       that the user who changes the contents of definitions files in the
//       Library will not necessarily be able to recompile the application
//       to use the modified definitions.)
//   .
//       b) Use a suitable shared library mechanism for linking with the
//       Library.  A suitable mechanism is one that (1) uses at run time a
//       copy of the library already present on the user's computer system,
//       rather than copying library functions into the executable, and (2)
//       will operate properly with a modified version of the library, if
//       the user installs one, as long as the modified version is
//       interface-compatible with the version that the work was made with.
//   .
//       c) Accompany the work with a written offer, valid for at
//       least three years, to give the same user the materials
//       specified in Subsection 6a, above, for a charge no more
//       than the cost of performing this distribution.
//   .
//       d) If distribution of the work is made by offering access to copy
//       from a designated place, offer equivalent access to copy the above
//       specified materials from the same place.
//   .
//       e) Verify that the user has already received a copy of these
//       materials or that you have already sent this user a copy.
//   .
//     For an executable, the required form of the "work that uses the
//   Library" must include any data and utility programs needed for
//   reproducing the executable from it.  However, as a special exception,
//   the materials to be distributed need not include anything that is
//   normally distributed (in either source or binary form) with the major
//   components (compiler, kernel, and so on) of the operating system on
//   which the executable runs, unless that component itself accompanies
//   the executable.
//   .
//     It may happen that this requirement contradicts the license
//   restrictions of other proprietary libraries that do not normally
//   accompany the operating system.  Such a contradiction means you cannot
//   use both them and the Library together in an executable that you
//   distribute.
//   .
//     7. You may place library facilities that are a work based on the
//   Library side-by-side in a single library together with other library
//   facilities not covered by this License, and distribute such a combined
//   library, provided that the separate distribution of the work based on
//   the Library and of the other library facilities is otherwise
//   permitted, and provided that you do these two things:
//   .
//       a) Accompany the combined library with a copy of the same work
//       based on the Library, uncombined with any other library
//       facilities.  This must be distributed under the terms of the
//       Sections above.
//   .
//       b) Give prominent notice with the combined library of the fact
//       that part of it is a work based on the Library, and explaining
//       where to find the accompanying uncombined form of the same work.
//   .
//     8. You may not copy, modify, sublicense, link with, or distribute
//   the Library except as expressly provided under this License.  Any
//   attempt otherwise to copy, modify, sublicense, link with, or
//   distribute the Library is void, and will automatically terminate your
//   rights under this License.  However, parties who have received copies,
//   or rights, from you under this License will not have their licenses
//   terminated so long as such parties remain in full compliance.
//   .
//     9. You are not required to accept this License, since you have not
//   signed it.  However, nothing else grants you permission to modify or
//   distribute the Library or its derivative works.  These actions are
//   prohibited by law if you do not accept this License.  Therefore, by
//   modifying or distributing the Library (or any work based on the
//   Library), you indicate your acceptance of this License to do so, and
//   all its terms and conditions for copying, distributing or modifying
//   the Library or works based on it.
//   .
//     10. Each time you redistribute the Library (or any work based on the
//   Library), the recipient automatically receives a license from the
//   original licensor to copy, distribute, link with or modify the Library
//   subject to these terms and conditions.  You may not impose any further
//   restrictions on the recipients' exercise of the rights granted herein.
//   You are not responsible for enforcing compliance by third parties with
//   this License.
//   .
//     11. If, as a consequence of a court judgment or allegation of patent
//   infringement or for any other reason (not limited to patent issues),
//   conditions are imposed on you (whether by court order, agreement or
//   otherwise) that contradict the conditions of this License, they do not
//   excuse you from the conditions of this License.  If you cannot
//   distribute so as to satisfy simultaneously your obligations under this
//   License and any other pertinent obligations, then as a consequence you
//   may not distribute the Library at all.  For example, if a patent
//   license would not permit royalty-free redistribution of the Library by
//   all those who receive copies directly or indirectly through you, then
//   the only way you could satisfy both it and this License would be to
//   refrain entirely from distribution of the Library.
//   .
//   If any portion of this section is held invalid or unenforceable under any
//   particular circumstance, the balance of the section is intended to apply,
//   and the section as a whole is intended to apply in other circumstances.
//   .
//   It is not the purpose of this section to induce you to infringe any
//   patents or other property right claims or to contest validity of any
//   such claims; this section has the sole purpose of protecting the
//   integrity of the free software distribution system which is
//   implemented by public license practices.  Many people have made
//   generous contributions to the wide range of software distributed
//   through that system in reliance on consistent application of that
//   system; it is up to the author/donor to decide if he or she is willing
//   to distribute software through any other system and a licensee cannot
//   impose that choice.
//   .
//   This section is intended to make thoroughly clear what is believed to
//   be a consequence of the rest of this License.
//   .
//     12. If the distribution and/or use of the Library is restricted in
//   certain countries either by patents or by copyrighted interfaces, the
//   original copyright holder who places the Library under this License may add
//   an explicit geographical distribution limitation excluding those countries,
//   so that distribution is permitted only in or among countries not thus
//   excluded.  In such case, this License incorporates the limitation as if
//   written in the body of this License.
//   .
//     13. The Free Software Foundation may publish revised and/or new
//   versions of the Lesser General Public License from time to time.
//   Such new versions will be similar in spirit to the present version,
//   but may differ in detail to address new problems or concerns.
//   .
//   Each version is given a distinguishing version number.  If the Library
//   specifies a version number of this License which applies to it and
//   "any later version", you have the option of following the terms and
//   conditions either of that version or of any later version published by
//   the Free Software Foundation.  If the Library does not specify a
//   license version number, you may choose any version ever published by
//   the Free Software Foundation.
//   .
//     14. If you wish to incorporate parts of the Library into other free
//   programs whose distribution conditions are incompatible with these,
//   write to the author to ask for permission.  For software which is
//   copyrighted by the Free Software Foundation, write to the Free
//   Software Foundation; we sometimes make exceptions for this.  Our
//   decision will be guided by the two goals of preserving the free status
//   of all derivatives of our free software and of promoting the sharing
//   and reuse of software generally.
//   .
//                   NO WARRANTY
//   .
//     15. BECAUSE THE LIBRARY IS LICENSED FREE OF CHARGE, THERE IS NO
//   WARRANTY FOR THE LIBRARY, TO THE EXTENT PERMITTED BY APPLICABLE LAW.
//   EXCEPT WHEN OTHERWISE STATED IN WRITING THE COPYRIGHT HOLDERS AND/OR
//   OTHER PARTIES PROVIDE THE LIBRARY "AS IS" WITHOUT WARRANTY OF ANY
//   KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE
//   IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
//   PURPOSE.  THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE
//   LIBRARY IS WITH YOU.  SHOULD THE LIBRARY PROVE DEFECTIVE, YOU ASSUME
//   THE COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION.
//   .
//     16. IN NO EVENT UNLESS REQUIRED BY APPLICABLE LAW OR AGREED TO IN
//   WRITING WILL ANY COPYRIGHT HOLDER, OR ANY OTHER PARTY WHO MAY MODIFY
//   AND/OR REDISTRIBUTE THE LIBRARY AS PERMITTED ABOVE, BE LIABLE TO YOU
//   FOR DAMAGES, INCLUDING ANY GENERAL, SPECIAL, INCIDENTAL OR
//   CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE THE
//   LIBRARY (INCLUDING BUT NOT LIMITED TO LOSS OF DATA OR DATA BEING
//   RENDERED INACCURATE OR LOSSES SUSTAINED BY YOU OR THIRD PARTIES OR A
//   FAILURE OF THE LIBRARY TO OPERATE WITH ANY OTHER SOFTWARE), EVEN IF
//   SUCH HOLDER OR OTHER PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
//   DAMAGES.
//   .
//                END OF TERMS AND CONDITIONS
//   .
//              How to Apply These Terms to Your New Libraries
//   .
//     If you develop a new library, and you want it to be of the greatest
//   possible use to the public, we recommend making it free software that
//   everyone can redistribute and change.  You can do so by permitting
//   redistribution under these terms (or, alternatively, under the terms of the
//   ordinary General Public License).
//   .
//     To apply these terms, attach the following notices to the library.  It is
//   safest to attach them to the start of each source file to most effectively
//   convey the exclusion of warranty; and each file should have at least the
//   "copyright" line and a pointer to where the full notice is found.
//   .
//       <one line to give the library's name and a brief idea of what it does.>
//       Copyright (C) <year>  <name of author>
//   .
//       This library is free software; you can redistribute it and/or
//       modify it under the terms of the GNU Lesser General Public
//       License as published by the Free Software Foundation; either
//       version 2.1 of the License, or (at your option) any later version.
//   .
//       This library is distributed in the hope that it will be useful,
//       but WITHOUT ANY WARRANTY; without even the implied warranty of
//       MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
//       Lesser General Public License for more details.
//   .
//       You should have received a copy of the GNU Lesser General Public
//       License along with this library; if not, write to the Free Software
//       Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301  USA
//   .
//   Also add information on how to contact you by electronic and paper mail.
//   .
//   You should also get your employer (if you work as a programmer) or your
//   school, if any, to sign a "copyright disclaimer" for the library, if
//   necessary.  Here is a sample; alter the names:
//   .
//     Yoyodyne, Inc., hereby disclaims all copyright interest in the
//     library `Frob' (a library for tweaking knobs) written by James Random Hacker.
//   .
//     <signature of Ty Coon>, 1 April 1990
//     Ty Coon, President of Vice
//   .
//   That's all there is to it!
// "use strict";

export default function SubtitlesOctopus(options) {
  var supportsWebAssembly = false;
  try {
    if (
      typeof WebAssembly === "object" &&
      typeof WebAssembly.instantiate === "function"
    ) {
      const module = new WebAssembly.Module(
        Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00)
      );
      if (module instanceof WebAssembly.Module)
        supportsWebAssembly =
          new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
    }
  } catch (e) {}
  // console.log(
  //   "WebAssembly support detected: " + (supportsWebAssembly ? "yes" : "no")
  // );

  var self = this;
  self.canvas = options.canvas; // HTML canvas element (optional if video specified)
  self.renderMode =
    options.renderMode || (options.lossyRender ? "lossy" : "wasm-blend");
  self.libassMemoryLimit = options.libassMemoryLimit || 0;
  self.libassGlyphLimit = options.libassGlyphLimit || 0;
  self.targetFps = options.targetFps || 24;
  self.prescaleFactor = options.prescaleFactor || 1.0;
  self.prescaleHeightLimit = options.prescaleHeightLimit || 1080;
  self.maxRenderHeight = options.maxRenderHeight || 0; // 0 - no limit
  self.dropAllAnimations = options.dropAllAnimations || false; // attempt to remove all animations as a last ditch effort for displaying on weak hardware; may severly mangle subtitles if enabled
  self.isOurCanvas = false; // (internal) we created canvas and manage it
  self.video = options.video; // HTML video element (optional if canvas specified)
  self.canvasParent = null; // (internal) HTML canvas parent element
  self.fonts = options.fonts || []; // Array with links to fonts used in sub (optional)
  self.availableFonts = options.availableFonts || []; // Object with all available fonts (optional). Key is font name in lower case, value is link: {"arial": "/font1.ttf"}
  self.onReadyEvent = options.onReady; // Function called when SubtitlesOctopus is ready (optional)
  if (supportsWebAssembly) {
    self.workerUrl = options.workerUrl || "subtitles-octopus-worker.js"; // Link to WebAssembly worker
  } else {
    self.workerUrl =
      options.legacyWorkerUrl || "subtitles-octopus-worker-legacy.js"; // Link to legacy worker
  }
  self.subUrl = options.subUrl; // Link to sub file (optional if subContent specified)
  self.subContent = options.subContent || null; // Sub content (optional if subUrl specified)
  self.onErrorEvent = options.onError; // Function called in case of critical error meaning sub wouldn't be shown and you should use alternative method (for instance it occurs if browser doesn't support web workers).
  self.debug = options.debug || false; // When debug enabled, some performance info printed in console.
  self.lastRenderTime = 0; // (internal) Last time we got some frame from worker
  self.pixelRatio = window.devicePixelRatio || 1; // (internal) Device pixel ratio (for high dpi devices)

  self.timeOffset = options.timeOffset || 0; // Time offset would be applied to currentTime from video (option)

  self.hasAlphaBug = false;

  (function () {
    if (typeof ImageData.prototype.constructor === "function") {
      try {
        // try actually calling ImageData, as on some browsers it's reported
        // as existing but calling it errors out as "TypeError: Illegal constructor"
        new window.ImageData(new Uint8ClampedArray([0, 0, 0, 0]), 1, 1);
        return;
      } catch (e) {
        console.log(
          "detected that ImageData is not constructable despite browser saying so"
        );
      }
    }

    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    window.ImageData = function () {
      var i = 0;
      if (arguments[0] instanceof Uint8ClampedArray) {
        var data = arguments[i++];
      }
      var width = arguments[i++];
      var height = arguments[i];

      var imageData = ctx.createImageData(width, height);
      if (data) imageData.data.set(data);
      return imageData;
    };
  })();

  self.workerError = function (error) {
    console.error("Worker error: ", error);
    if (self.onErrorEvent) {
      self.onErrorEvent(error);
    }
    if (!self.debug) {
      self.dispose();
      throw new Error("Worker error: " + error);
    }
  };

  // Not tested for repeated usage yet
  self.init = function () {
    if (!window.Worker) {
      self.workerError("worker not supported");
      return;
    }
    // Worker
    if (!self.worker) {
      self.worker = new Worker(self.workerUrl);
      self.worker.addEventListener("message", self.onWorkerMessage);
      self.worker.addEventListener("error", self.workerError);
    }
    self.workerActive = false;
    self.createCanvas();
    self.setVideo(options.video);
    self.setSubUrl(options.subUrl);
    self.worker.postMessage({
      target: "worker-init",
      width: self.canvas.width,
      height: self.canvas.height,
      URL: document.URL,
      currentScript: self.workerUrl,
      preMain: true,
      renderMode: self.renderMode,
      subUrl: self.subUrl,
      subContent: self.subContent,
      fonts: self.fonts,
      availableFonts: self.availableFonts,
      debug: self.debug,
      targetFps: self.targetFps,
      libassMemoryLimit: self.libassMemoryLimit,
      libassGlyphLimit: self.libassGlyphLimit,
      dropAllAnimations: self.dropAllAnimations,
    });
  };

  self.createCanvas = function () {
    if (!self.canvas) {
      if (self.video) {
        self.isOurCanvas = true;
        self.canvas = document.createElement("canvas");
        self.canvas.className = "libassjs-canvas";
        self.canvas.style.display = "none";

        self.canvasParent = document.createElement("div");
        self.canvasParent.className = "libassjs-canvas-parent";
        self.canvasParent.appendChild(self.canvas);

        if (self.video.nextSibling) {
          self.video.parentNode.insertBefore(
            self.canvasParent,
            self.video.nextSibling
          );
        } else {
          self.video.parentNode.appendChild(self.canvasParent);
        }
      } else {
        if (!self.canvas) {
          self.workerError(
            "Don't know where to render: you should give video or canvas in options."
          );
        }
      }
    }
    self.ctx = self.canvas.getContext("2d", { willReadFrequently: true });
    self.bufferCanvas = document.createElement("canvas", {
      willReadFrequently: true,
    });
    self.bufferCanvasCtx = self.bufferCanvas.getContext("2d");

    // test for alpha bug, where e.g. WebKit can render a transparent pixel
    // (with alpha == 0) as non-black which then leads to visual artifacts
    self.bufferCanvas.width = 1;
    self.bufferCanvas.height = 1;
    var testBuf = new Uint8ClampedArray([0, 255, 0, 0]);
    var testImage = new ImageData(testBuf, 1, 1);
    self.bufferCanvasCtx.clearRect(0, 0, 1, 1);
    self.ctx.clearRect(0, 0, 1, 1);
    var prePut = self.ctx.getImageData(0, 0, 1, 1).data;
    self.bufferCanvasCtx.putImageData(testImage, 0, 0);
    self.ctx.drawImage(self.bufferCanvas, 0, 0);
    var postPut = self.ctx.getImageData(0, 0, 1, 1).data;
    self.hasAlphaBug = prePut[1] != postPut[1];
    if (self.hasAlphaBug) {
      console.log(
        "Detected a browser having issue with transparent pixels, applying workaround"
      );
    }
  };

  function onTimeUpdate() {
    self.setCurrentTime(self.video.currentTime + self.timeOffset);
  }

  function onPlaying() {
    self.setIsPaused(false, self.video.currentTime + self.timeOffset);
  }

  function onPause() {
    self.setIsPaused(true, self.video.currentTime + self.timeOffset);
  }

  function onSeeking() {
    self.video.removeEventListener("timeupdate", onTimeUpdate, false);
  }

  function onSeeked() {
    self.video.addEventListener("timeupdate", onTimeUpdate, false);

    var currentTime = self.video.currentTime + self.timeOffset;

    self.setCurrentTime(currentTime);
  }

  function onRateChange() {
    self.setRate(self.video.playbackRate);
  }

  function onWaiting() {
    self.setIsPaused(true, self.video.currentTime + self.timeOffset);
  }

  function onLoadedMetadata(e) {
    e.target.removeEventListener(e.type, onLoadedMetadata, false);
    self.resize();
  }

  self.setVideo = function (video) {
    self.video = video;
    if (self.video) {
      self.video.addEventListener("timeupdate", onTimeUpdate, false);
      self.video.addEventListener("playing", onPlaying, false);
      self.video.addEventListener("pause", onPause, false);
      self.video.addEventListener("seeking", onSeeking, false);
      self.video.addEventListener("seeked", onSeeked, false);
      self.video.addEventListener("ratechange", onRateChange, false);
      self.video.addEventListener("waiting", onWaiting, false);

      document.addEventListener(
        "fullscreenchange",
        self.resizeWithTimeout,
        false
      );
      document.addEventListener(
        "mozfullscreenchange",
        self.resizeWithTimeout,
        false
      );
      document.addEventListener(
        "webkitfullscreenchange",
        self.resizeWithTimeout,
        false
      );
      document.addEventListener(
        "msfullscreenchange",
        self.resizeWithTimeout,
        false
      );
      window.addEventListener("resize", self.resizeWithTimeout, false);

      // Support Element Resize Observer
      if (typeof ResizeObserver !== "undefined") {
        self.ro = new ResizeObserver(self.resizeWithTimeout);
        self.ro.observe(self.video);
      }

      if (self.video.videoWidth > 0) {
        self.resize();
      } else {
        self.video.addEventListener("loadedmetadata", onLoadedMetadata, false);
      }
    }
  };

  self.getVideoPosition = function () {
    var videoRatio = self.video.videoWidth / self.video.videoHeight;
    var width = self.video.offsetWidth,
      height = self.video.offsetHeight;
    var elementRatio = width / height;
    var realWidth = width,
      realHeight = height;
    if (elementRatio > videoRatio) realWidth = Math.floor(height * videoRatio);
    else realHeight = Math.floor(width / videoRatio);

    var x = (width - realWidth) / 2;
    var y = (height - realHeight) / 2;

    return {
      width: realWidth,
      height: realHeight,
      x: x,
      y: y,
    };
  };

  self.setSubUrl = function (subUrl) {
    self.subUrl = subUrl;
  };

  self.renderFrameData = null;
  function renderFrames() {
    var data = self.renderFramesData;
    var beforeDrawTime = performance.now();
    self.ctx.clearRect(0, 0, self.canvas.width, self.canvas.height);
    for (var i = 0; i < data.canvases.length; i++) {
      var image = data.canvases[i];
      self.bufferCanvas.width = image.w;
      self.bufferCanvas.height = image.h;
      var imageBuffer = new Uint8ClampedArray(image.buffer);
      if (self.hasAlphaBug) {
        for (var j = 3; j < imageBuffer.length; j = j + 4) {
          imageBuffer[j] = imageBuffer[j] >= 1 ? imageBuffer[j] : 1;
        }
      }
      var imageData = new ImageData(imageBuffer, image.w, image.h);
      self.bufferCanvasCtx.putImageData(imageData, 0, 0);
      self.ctx.drawImage(self.bufferCanvas, image.x, image.y);
    }
    if (self.debug) {
      var drawTime = Math.round(performance.now() - beforeDrawTime);
      var blendTime = data.blendTime;
      if (typeof blendTime !== "undefined") {
        console.log(
          "render: " +
            Math.round(data.spentTime - blendTime) +
            " ms, blend: " +
            Math.round(blendTime) +
            " ms, draw: " +
            drawTime +
            " ms; TOTAL=" +
            Math.round(data.spentTime + drawTime) +
            " ms"
        );
      } else {
        console.log(
          Math.round(data.spentTime) + " ms (+ " + drawTime + " ms draw)"
        );
      }
      self.renderStart = performance.now();
    }
  }

  /**
   * Lossy Render Mode
   *
   */
  function renderFastFrames() {
    var data = self.renderFramesData;
    var beforeDrawTime = performance.now();
    self.ctx.clearRect(0, 0, self.canvas.width, self.canvas.height);
    for (var i = 0; i < data.bitmaps.length; i++) {
      var image = data.bitmaps[i];
      self.ctx.drawImage(image.bitmap, image.x, image.y);
    }
    if (self.debug) {
      var drawTime = Math.round(performance.now() - beforeDrawTime);
      console.log(
        data.bitmaps.length +
          " bitmaps, libass: " +
          Math.round(data.libassTime) +
          "ms, decode: " +
          Math.round(data.decodeTime) +
          "ms, draw: " +
          drawTime +
          "ms"
      );
      self.renderStart = performance.now();
    }
  }

  self.workerActive = false;
  self.frameId = 0;
  self.onWorkerMessage = function (event) {
    //dump('\nclient got ' + JSON.stringify(event.data).substr(0, 150) + '\n');
    if (!self.workerActive) {
      self.workerActive = true;
      if (self.onReadyEvent) {
        self.onReadyEvent();
      }
    }
    var data = event.data;
    switch (data.target) {
      case "stdout": {
        console.log(data.content);
        break;
      }
      case "console-log": {
        console.log.apply(console, JSON.parse(data.content));
        break;
      }
      case "console-debug": {
        console.debug.apply(console, JSON.parse(data.content));
        break;
      }
      case "console-info": {
        console.info.apply(console, JSON.parse(data.content));
        break;
      }
      case "console-warn": {
        console.warn.apply(console, JSON.parse(data.content));
        break;
      }
      case "console-error": {
        console.error.apply(console, JSON.parse(data.content));
        break;
      }
      case "stderr": {
        console.error(data.content);
        break;
      }
      case "window": {
        window[data.method]();
        break;
      }
      case "canvas": {
        switch (data.op) {
          case "getContext": {
            self.ctx = self.canvas.getContext(data.type, data.attributes);
            break;
          }
          case "resize": {
            self.resize(data.width, data.height);
            break;
          }
          case "renderCanvas": {
            if (self.lastRenderTime < data.time) {
              self.lastRenderTime = data.time;
              self.renderFramesData = data;
              window.requestAnimationFrame(renderFrames);
            }
            break;
          }
          case "renderFastCanvas": {
            if (self.lastRenderTime < data.time) {
              self.lastRenderTime = data.time;
              self.renderFramesData = data;
              window.requestAnimationFrame(renderFastFrames);
            }
            break;
          }
          case "setObjectProperty": {
            self.canvas[data.object][data.property] = data.value;
            break;
          }
          default:
            throw "eh?";
        }
        break;
      }
      case "tick": {
        self.frameId = data.id;
        self.worker.postMessage({
          target: "tock",
          id: self.frameId,
        });
        break;
      }
      case "custom": {
        if (self["onCustomMessage"]) {
          self["onCustomMessage"](event);
        } else {
          throw "Custom message received but client onCustomMessage not implemented.";
        }
        break;
      }
      case "setimmediate": {
        self.worker.postMessage({
          target: "setimmediate",
        });
        break;
      }
      case "get-events": {
        break;
      }
      case "get-styles": {
        break;
      }
      case "ready": {
        break;
      }
      default:
        throw "what? " + data.target;
    }
  };

  function _computeCanvasSize(width, height) {
    var scalefactor = self.prescaleFactor <= 0 ? 1.0 : self.prescaleFactor;

    if (height <= 0 || width <= 0) {
      width = 0;
      height = 0;
    } else {
      var sgn = scalefactor < 1 ? -1 : 1;
      var newH = height;
      if (sgn * newH * scalefactor <= sgn * self.prescaleHeightLimit)
        newH *= scalefactor;
      else if (sgn * newH < sgn * self.prescaleHeightLimit)
        newH = self.prescaleHeightLimit;

      if (self.maxRenderHeight > 0 && newH > self.maxRenderHeight)
        newH = self.maxRenderHeight;

      width *= newH / height;
      height = newH;
    }

    return { width: width, height: height };
  }

  self.resize = function (width, height, top, left) {
    var videoSize = null;
    top = top || 0;
    left = left || 0;
    if ((!width || !height) && self.video) {
      videoSize = self.getVideoPosition();
      var newSize = _computeCanvasSize(
        videoSize.width * self.pixelRatio,
        videoSize.height * self.pixelRatio
      );
      width = newSize.width;
      height = newSize.height;
      var offset =
        self.canvasParent.getBoundingClientRect().top -
        self.video.getBoundingClientRect().top;
      top = videoSize.y - offset;
      left = videoSize.x;
    }
    if (!width || !height) {
      if (!self.video) {
        console.error(
          "width or height is 0. You should specify width & height for resize."
        );
      }
      return;
    }

    if (
      self.canvas.width != width ||
      self.canvas.height != height ||
      self.canvas.style.top != top ||
      self.canvas.style.left != left
    ) {
      self.canvas.width = width;
      self.canvas.height = height;

      if (videoSize != null) {
        self.canvasParent.style.position = "relative";
        self.canvas.style.display = "block";
        self.canvas.style.position = "absolute";
        self.canvas.style.width = videoSize.width + "px";
        self.canvas.style.height = videoSize.height + "px";
        self.canvas.style.top = top + "px";
        self.canvas.style.left = left + "px";
        self.canvas.style.pointerEvents = "none";
      }

      self.worker.postMessage({
        target: "canvas",
        width: self.canvas.width,
        height: self.canvas.height,
      });
    }
  };

  self.resizeWithTimeout = function () {
    self.resize();
    setTimeout(self.resize, 100);
  };

  self.runBenchmark = function () {
    self.worker.postMessage({
      target: "runBenchmark",
    });
  };

  self.customMessage = function (data, options) {
    options = options || {};
    self.worker.postMessage({
      target: "custom",
      userData: data,
      preMain: options.preMain,
    });
  };

  self.setCurrentTime = function (currentTime) {
    self.worker.postMessage({
      target: "video",
      currentTime: currentTime,
    });
  };

  self.setTrackByUrl = function (url) {
    self.worker.postMessage({
      target: "set-track-by-url",
      url: url,
    });
  };

  self.setTrack = function (content) {
    self.worker.postMessage({
      target: "set-track",
      content: content,
    });
  };

  self.freeTrack = function (content) {
    self.worker.postMessage({
      target: "free-track",
    });
  };

  self.render = self.setCurrentTime;

  self.setIsPaused = function (isPaused, currentTime) {
    self.worker.postMessage({
      target: "video",
      isPaused: isPaused,
      currentTime: currentTime,
    });
  };

  self.setRate = function (rate) {
    self.worker.postMessage({
      target: "video",
      rate: rate,
    });
  };

  self.dispose = function () {
    if (self.worker) {
      self.worker.postMessage({
        target: "destroy",
      });

      self.worker.terminate();
      self.worker.removeEventListener("message", self.onWorkerMessage);
      self.worker.removeEventListener("error", self.workerError);
      self.workerActive = false;
      self.worker = null;
    }

    // Remove the canvas element to remove residual subtitles rendered on player
    if (self.video) {
      self.video.removeEventListener("timeupdate", onTimeUpdate, false);
      self.video.removeEventListener("playing", onPlaying, false);
      self.video.removeEventListener("pause", onPause, false);
      self.video.removeEventListener("seeking", onSeeking, false);
      self.video.removeEventListener("seeked", onSeeked, false);
      self.video.removeEventListener("ratechange", onRateChange, false);
      self.video.removeEventListener("waiting", onWaiting, false);
      self.video.removeEventListener("loadedmetadata", onLoadedMetadata, false);

      document.removeEventListener(
        "fullscreenchange",
        self.resizeWithTimeout,
        false
      );
      document.removeEventListener(
        "mozfullscreenchange",
        self.resizeWithTimeout,
        false
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        self.resizeWithTimeout,
        false
      );
      document.removeEventListener(
        "msfullscreenchange",
        self.resizeWithTimeout,
        false
      );
      window.removeEventListener("resize", self.resizeWithTimeout, false);

      try {
        self.video.parentNode.removeChild(self.canvasParent);
      } catch {}

      self.video = null;
    }

    if (self.ro) {
      self.ro.disconnect();
      self.ro = null;
    }

    self.onCustomMessage = null;
    self.onErrorEvent = null;
    self.onReadyEvent = null;
  };

  self.fetchFromWorker = function (workerOptions, onSuccess, onError) {
    try {
      var target = workerOptions["target"];

      var timeout = setTimeout(function () {
        reject(Error("Error: Timeout while try to fetch " + target));
      }, 5000);

      var resolve = function (event) {
        if (event.data.target == target) {
          onSuccess(event.data);
          self.worker.removeEventListener("message", resolve);
          self.worker.removeEventListener("error", reject);
          clearTimeout(timeout);
        }
      };

      var reject = function (event) {
        onError(event);
        self.worker.removeEventListener("message", resolve);
        self.worker.removeEventListener("error", reject);
        clearTimeout(timeout);
      };

      self.worker.addEventListener("message", resolve);
      self.worker.addEventListener("error", reject);

      self.worker.postMessage(workerOptions);
    } catch (error) {
      onError(error);
    }
  };

  self.createEvent = function (event) {
    self.worker.postMessage({
      target: "create-event",
      event: event,
    });
  };

  self.getEvents = function (onSuccess, onError) {
    self.fetchFromWorker(
      {
        target: "get-events",
      },
      function (data) {
        onSuccess(data.events);
      },
      onError
    );
  };

  self.setEvent = function (event, index) {
    self.worker.postMessage({
      target: "set-event",
      event: event,
      index: index,
    });
  };

  self.removeEvent = function (index) {
    self.worker.postMessage({
      target: "remove-event",
      index: index,
    });
  };

  self.createStyle = function (style) {
    self.worker.postMessage({
      target: "create-style",
      style: style,
    });
  };

  self.getStyles = function (onSuccess, onError) {
    self.fetchFromWorker(
      {
        target: "get-styles",
      },
      function (data) {
        onSuccess(data.styles);
      },
      onError
    );
  };

  self.setStyle = function (style, index) {
    self.worker.postMessage({
      target: "set-style",
      style: style,
      index: index,
    });
  };

  self.removeStyle = function (index) {
    self.worker.postMessage({
      target: "remove-style",
      index: index,
    });
  };

  self.init();
}

if (typeof SubtitlesOctopusOnLoad == "function") {
  SubtitlesOctopusOnLoad();
}

if (typeof exports !== "undefined") {
  if (typeof module !== "undefined" && module.exports) {
    exports = module.exports = SubtitlesOctopus;
  }
}
